export enum MaterialTypeEnum {
  Laminate = 0,
  Compact = 1,
  Solid = 2,
  Quartz = 3,
}
